import AnimatedPage from "../components/animatedPage/AnimatedPage";
const Contacts = () => {
    return (
		<AnimatedPage>
		<main className="section">
			<div className="container">
				<h1 className="title-1">Contacts</h1>

				<ul className="content-list">
					<li className="content-list__item">
						<h2 className="title-2">Location</h2>
						<p>Porto, Portugal</p>
					</li>
					<li className="content-list__item">
						<h2 className="title-2">Email</h2>
						<p>
							<a href="mailto:pedronunes0028@gmail.com">
								pedronunes0028@gmail.com
							</a>
						</p>
					</li>
				</ul>
			</div>
		</main>
		</AnimatedPage>
	);
}

export default Contacts;